import type { FreeReading } from '../types';
import { isCurrentFreeReading, isHistoricalFreeV2Reading, isHistoricalFreeV3Reading } from '../types/reading-schemas';
import { focusLanguage } from './focus-language';

export interface FreeReadingPresentation {
  sourceVersion: 'free-v4' | 'free-v3' | 'free-v2' | 'legacy';
  title: string;
  personalizedReading?: string;
  celestialSignature?: string;
  coreEnergy?: string;
  legacyFocusContext?: string;
  currentCycle?: string;
  strength?: string;
  growthEdge?: string;
  salesBridge?: string;
  selectedFocusLabel?: string;
}

function currentLanguage(value: string): string {
  return value.replace(/\bcore pattern\b/giu, 'core energy');
}

function horizonNeutralBridge(value: string): string {
  return /\b(?:next\s+)?six[- ]month|\bsix months\b/iu.test(value)
    ? 'Your preview reveals the central pattern. The complete reading follows how it may develop across the period you choose, including opportunities, cautions, and practical guidance without promising a fixed outcome.'
    : value;
}

export function presentFreeReading(reading: FreeReading, fallbackFocusLabel?: string): FreeReadingPresentation {
  if (isCurrentFreeReading(reading)) {
    return {
      sourceVersion: 'free-v4',
      title: reading.title,
      personalizedReading: reading.personalized_reading,
      selectedFocusLabel: focusLanguage(reading.selected_focus).heading,
    };
  }
  if (isHistoricalFreeV3Reading(reading)) return {
    sourceVersion:'free-v3', title:reading.title, celestialSignature:reading.celestial_signature,
    currentCycle:reading.current_cycle, strength:reading.strength, growthEdge:reading.growth_edge,
    selectedFocusLabel:focusLanguage(reading.selected_focus).heading,
  };
  if (isHistoricalFreeV2Reading(reading)) return {
    sourceVersion:'free-v2', title:reading.title, celestialSignature:reading.celestial_signature,
    coreEnergy:reading.core_energy, currentCycle:reading.current_cycle, strength:reading.strength,
    growthEdge:reading.growth_edge, salesBridge:reading.sales_bridge, selectedFocusLabel:reading.selected_focus_label,
  };
  return {
    sourceVersion: 'legacy',
    title: reading.title,
    celestialSignature: currentLanguage(reading.celestial_signature),
    coreEnergy: currentLanguage(reading.core_pattern),
    legacyFocusContext: currentLanguage(reading.focus_insight),
    currentCycle: currentLanguage(reading.current_cycle),
    strength: currentLanguage(reading.strength),
    growthEdge: currentLanguage(reading.growth_edge),
    salesBridge: horizonNeutralBridge(currentLanguage(reading.paid_teaser)),
    selectedFocusLabel: fallbackFocusLabel,
  };
}
